import { render, staticRenderFns } from "./mySignUpTraining.vue?vue&type=template&id=0c81a1f8"
import script from "./mySignUpTraining.vue?vue&type=script&lang=js"
export * from "./mySignUpTraining.vue?vue&type=script&lang=js"
import style0 from "./mySignUpTraining.vue?vue&type=style&index=0&id=0c81a1f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports